<template>
  <el-select
    v-model="salesInvoiceModel"
    @change="salesInvoiceChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.SALES_INVOICE')"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    remote
    :remote-method="getSalesInvoices"
    :loading="loading"
  >
    <el-option v-if="showAll" :value="null" :label="$t('COMMON.SALES_INVOICE')">
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
    </el-option>
    <el-option
      v-for="salesInvoice in salesInvoices"
      :key="salesInvoice.id"
      :value="salesInvoice.id"
      :label="`${salesInvoice.code}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "sales-invoice-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    salesInvoice: {
      type: String,
      default: null,
      description: "SalesInvoice id",
    },
    filterReseller: {
      type: String,
      default: null,
      description: "Reseller id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterStatus: {
      type: String,
      default: null,
      description: "SalesInvoice status",
    },
  },

  data() {
    return {
      salesInvoiceModel: this.salesInvoice,
      salesInvoices: {},
    };
  },

  setup() {},

  created() {
    this.getSalesInvoices(null, this.salesInvoice);
  },

  methods: {
    async getSalesInvoices(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "-created_at",
          filter: {
            ...(query ? { code: query } : {}),
            ...(id ? { id: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }
        if (this.filterReseller) {
          params = {
            ...params,
            filter: { ...params.filter, reseller: this.filterReseller },
          };
        }
        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.filterStatus) {
          params = {
            ...params,
            filter: { ...params.filter, status: this.filterStatus },
          };
        }

        await this.$store.dispatch("salesInvoices/list", params);
        const salesInvoicesArr = await this.$store.getters[
          "salesInvoices/list"
        ];
        this.salesInvoices = {};
        salesInvoicesArr.forEach((salesInvoice) => {
          this.salesInvoices[salesInvoice.id] = salesInvoice;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    salesInvoiceChanged(salesInvoiceId) {
      const salesInvoice = Object.values(this.salesInvoices).find(
        (item) => item.id === salesInvoiceId
      );
      this.$emit("salesInvoiceChanged", salesInvoiceId, salesInvoice);
    },
  },

  watch: {
    salesInvoice(salesInvoice) {
      if (salesInvoice) {
        this.salesInvoiceModel = salesInvoice;
        if (salesInvoice !== this.salesInvoiceModel) {
          this.getSalesInvoices(null, salesInvoice);
        }
      } else {
        this.salesInvoiceModel = null;
      }
    },
    filterOrganization(filterOrganization) {
      this.getSalesInvoices();
    },
    filterReseller() {
      this.getSalesInvoices();
    },
    filterStatus() {
      this.getSalesInvoices();
    },
  },
};
</script>
